import { supabase } from "./api";

export const revalidate = 0;

export async function getAllData() {
  const { data, error } = await supabase.from("sessionscheduleview").select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getDataWithType(type) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .select()
    .eq("type", type);

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getInstructorIdData(instructorId,studentId) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .select()
    .eq("studentId", studentId)
    .or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`);

  if (error) {
    throw new Error("Failed to fetch data", error);
  }

  return data;
}

export async function getInstructorDatawithClass(instructorId, classId) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .select()
    .or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
    .eq("classId", classId);

  if (error) {
    throw new Error("Failed to fetch data", error);
  }

  return data;
}

export async function getIdData(id) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .select()
    .eq("id", id);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getStudentIdData(id, cls) {
  const prm = `studentId.eq.${id},studentId.is.null`;
  //.or('studentId.eq.2,studentId.is.null')
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .select()
    //.eq('studentId', id);
    .or(prm)
    .eq("class", cls);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getInstructorStudent(id) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .select()
    .or(`instructorId.eq.${id},subinstructorId.eq.${id}`);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function addData(adata) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .insert(adata)
    .select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function updateData(udata) {
  console.log("udata", udata);
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .update(udata)
    .eq("id", udata.id)
    .select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function deleteIdData(id) {
  const { data, error } = await supabase
    .from("sessionscheduleview")
    .delete()
    .eq("id", id);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}
